const env = process.env.NODE_ENV || 'production';

let config = {
    production : {
        url: 'https://api.juphy.com',
        api: {
            url: 'https://api.juphy.com'
        },
        iframe: {
            url: 'https://ai.juphy.com'
        },
        ngrok: {
            url: 'https://juphy-api2.ngrok.io'
        },
        shopify: {
            redirect: {
                url: 'https://api.juphy.com/shopify/redirect'
            }
        }
    },
    staging : {
        url: 'https://staging-api.juphy.com',
        api: {
            url: 'https://staging-api.juphy.com'
        },
        iframe: {
            url: 'https://ai.juphy.com'
        },
        ngrok: {
            url: 'https://juphy-api2.ngrok.io'
        },
        shopify: {
            redirect: {
                url: 'https://juphy-api2.ngrok.io/shopify/redirect'
            }
        }
    },
    development : {
        url: 'http://127.0.0.1:5555',
        api: {
            url: 'http://127.0.0.1:5555'
        },
        iframe: {
            url: 'http://localhost:5173'
        },
        ngrok: {
            url: 'https://juphy-api2.ngrok.io'
        },
        shopify: {
            redirect: {
                url: 'https://juphy-api2.ngrok.io/shopify/redirect'
            }
        }
    }
 }


export default config[env]


// WEBPACK FOOTER //
// ./src/libs/config.js